// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"textButtonStyles_buttonWrapper__3S4jv","button":"textButtonStyles_button__1_ksx","active":"textButtonStyles_active__21h-q"};